var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verificacao-token"},[_c('div',{staticClass:"loading-text"},[_vm._v(" Aguarde, estamos verificando seu acesso ")]),_c('v-progress-circular',{attrs:{"size":70,"width":6,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }